// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3lvSc","colMaxWidth":"Table_colMaxWidth__2fbjp"};